const demo = "/_app/immutable/assets/glimmr-product-diagram.CjXUwnFL.png";
export {
  demo as default
};
